<zf-loading-indicator *ngIf="!deployments() || !deployments().length || actionInProgress() || refreshing()">
</zf-loading-indicator>

<zf-sidebar></zf-sidebar>

<div class="content">
    <div *ngIf="!!deployments()?.length && !refreshing()" class="container">
        <div id="actions">
            <button [disabled]="refreshing()" (click)="getDeployments()"><span>Refresh</span></button>
            <button *ngIf="!isProduction" [disabled]="targetDeployment()?.information?.status === null
                || targetDeployment()?.information?.status === Status.INITIALIZING
                || targetDeployment()?.information?.status === Status.CREATE_IN_PROGRESS
                " (click)="prepareDelete($event)" class="danger"><span>Delete</span></button>
            <button [disabled]="!targetDeployment() || targetDeployment().information.status !== null" class="danger"
                (click)="prepareActivation($event)">Provision</button>
            <button [disabled]="(targetDeployment()?.information?.status !== Status.COMPLETE
        && targetDeployment()?.information?.status !== Status.UPDATE_COMPLETED)" (click)="manage()">Manage</button>
        </div>
        <table class="stack-table stretched">
            <thead>
                <tr class="bordered-top-bottom">
                    <th>Serial Number</th>
                    <th>Description</th>
                    <th>Compute</th>
                    <th>Online Storage</th>
                    <th>Archive Storage</th>
                    <th>Days left</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let deployment of deployments(); let i = index">
                    <tr (click)="selectTargetDeployment($event, deployment)" class="dashed-border-bottom" [ngClass]="{
                            'highlighted': targetDeployment()?.serialNumber === deployment.serialNumber,
                            'warning-border': isDeploymentInWarningState(deployment),
                            'critical-border': isDeploymentInExpiringState(deployment)
                            }">
                        <td *ngIf="(deployment.information.status === Status.COMPLETE
                    || deployment.information.status === Status.UPDATE_COMPLETED);
                            then anchored
                            else plain">
                        </td>
                        <ng-template #anchored>
                            <td>
                                <a class="external" target="_blank" rel="noopener noreferrer"
                                    [href]="deployment.information.url.endsWith('.') ? deployment.information.url.stripLast() : deployment.information.url">{{
                                    deployment.serialNumber }}</a>
                            </td>
                        </ng-template>
                        <ng-template #plain>
                            <td><span>{{ deployment.serialNumber }}</span></td>
                        </ng-template>
                        <td>{{ deployment.description }}</td>
                        <td [ngSwitch]="true">
                            <!--We have new entitlements show the user the changes-->
                            <span *ngSwitchCase="!deployment.isComputeEqual" class="expired"
                                title="Click Update to take advantage of your new entitlements">
                                {{ deployment?.information?.deploymentSKU.compute?.quantity *
                                10 || 0 }} FCU > {{ deployment?.entitlement?.compute?.quantity *
                                10 || 0 }} FCU</span>
                            <!--Nothing is different-->
                            <span *ngSwitchCase="deployment.isComputeEqual">{{
                                deployment?.entitlement?.compute | SKU:'compute' }}</span>
                        </td>
                        <td [ngSwitch]="true">
                            <!--We have new entitlements show the user the changes-->
                            <span *ngSwitchCase="!deployment.isOnlineEqual" class="expired"
                                title="Click Update to take advantage of your new entitlements">
                                {{ deployment?.information?.deploymentSKU.onlineStorage?.quantity *
                                500 || 0 }} GB > {{ deployment?.entitlement?.onlineStorage?.quantity *
                                500 || 0 }} GB</span>
                            <!--Nothing is different-->
                            <span *ngSwitchCase="deployment.isOnlineEqual">{{
                                deployment?.entitlement?.onlineStorage | SKU:'online' }}</span>
                        </td>

                        <td [ngSwitch]="true">
                            <!--We have new entitlements show the user the changes-->
                            <span *ngSwitchCase="!deployment.isArchiveEqual" class="expired"
                                title="Click Update to take advantage of your new entitlements">
                                {{ deployment?.information?.deploymentSKU.archiveStorage?.quantity *
                                500 || 0 }} GB > {{ deployment?.entitlement?.archiveStorage?.quantity *
                                500 || 0 }} GB</span>
                            <!--Nothing is different-->
                            <span *ngSwitchCase="deployment.isArchiveEqual">{{
                                deployment?.entitlement?.archiveStorage | SKU:'archive' }}</span>
                        </td>
                        <td [ngSwitch]="true">
                            <!--We are fine - show the number of days, and adjust the class-->
                            <span *ngSwitchCase="deployment?.entitlement?.compute?.expiryDays > 0" [ngClass]="{
                                    'warning': isDeploymentInWarningState(deployment),
                                    'expired': isDeploymentInExpiringState(deployment)
                                }" [attr.title]="titleMessage(deployment)">
                                {{deployment?.entitlement?.compute?.expiryDays|| 0 }} Days </span>
                            <!--We have actually expired-->
                            <span *ngSwitchCase="deployment?.entitlement?.compute?.expiryDays <= 0" class="expired"
                                title="Your instance has expired">Expired</span>
                        </td>
                        <td [ngSwitch]="true">
                            <ng-container *ngSwitchCase="deployment.isEntitlementEqual">
                                <span *ngIf="deployment.information.status === Status.CREATE_FAILED
                                || deployment.information.status === Status.DELETE_IN_PROGRESS
                                || deployment.information.status === Status.DELETE_FAILED" class="status">{{
                                    deployment.information.status | pascalToHuman }}</span>
                                <button *ngIf="
                            !!deployment.information?.status
                            && deployment.information.status !== Status.CREATE_FAILED
                            && deployment.information.status !== Status.DELETE_IN_PROGRESS
                            && deployment.information.status !== Status.DELETE_FAILED
                        " class="info" (click)="prepareStatus($event, deployment)">
                                    {{deployment.information.status | pascalToHuman}}</button>
                            </ng-container>
                            <ng-container *ngSwitchCase="!deployment.isEntitlementEqual">
                                <button class="danger" (click)="prepareUpdate($event, deployment)">
                                    Apply Update</button>
                            </ng-container>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <zf-modal #activationModal *ngIf="!!targetDeployment()"
            [ngClass]="{'small-dialog': currentState() === ProvisionState.PRE_REQUISITE_FAILURE || currentState() === ProvisionState.CONFIRMATION || currentState() === ProvisionState.NOT_APPROVED || currentState() === ProvisionState.BLOCKED_BY_REQUEST }">
            <ng-container *ngIf="currentState() === ProvisionState.PROVISION" modal-header>Provision {{ productName }}
            </ng-container>
            <ng-container *ngIf="currentState() === ProvisionState.PROVISION" modal-body>
                <form>
                    <table class="stack-information-table">
                        <tr>
                            <th>Serial Number</th>
                            <td>
                                <input type="text" [ngModel]="targetDeployment().serialNumber" name="serialNumber"
                                    readonly />
                            </td>
                        </tr>
                        <tr title="'Confirm the deployment type for ' + productName"
                            [ngClass]="{'error': activatedStackInformation().error.get('deploymentType')}">
                            <th>
                                <span>Deployment Type</span>
                                <i>Deployment type for {{ productName }}, the default is Enterprise</i>
                                <span class="error-text"
                                    *ngIf="activatedStackInformation().error.get('deploymentType')">{{activatedStackInformation().error.get('deploymentType')}}</span>
                            </th>
                            <td>
                                <zf-dropdown [elements]="deploymentTypes" inputId="activate-deployment-types-select"
                                    (selectElement)="activatedStackInformation().deploymentType = $event"
                                    [value]="activatedStackInformation().deploymentType"
                                    placeholder="Select deployment type">
                                    <ng-template #zfDropdownElementTemplate let-deploymentType>
                                        <span>{{ deploymentType }}</span>
                                    </ng-template>
                                </zf-dropdown>
                            </td>
                        </tr>
                        <tr [title]="'Enter your ' + productName + ' Administrator Password'"
                            [ngClass]="{'error': activatedStackInformation().error.get('password')}">
                            <th>
                                <span>Administrator Password</span>
                                <i>Console administrator password</i>
                                <span class="error-text"
                                    *ngIf="activatedStackInformation().error.get('password')">{{activatedStackInformation().error.get('password')}}</span>
                            </th>
                            <td>
                                <input type="password" [(ngModel)]="activatedStackInformation().adminPassword"
                                    name="password" />
                            </td>
                        </tr>
                        <tr [title]="'Confirm your ' + productName + ' Administrator Password'"
                            [ngClass]="{'error': activatedStackInformation().error.get('confirm-password')}">
                            <th style="white-space:pre-wrap; max-width: 300px;">
                                <span>Confirm Administrator Password</span>
                                <i>Confirm console administrator password</i>
                                <span class="error-text"
                                    *ngIf="activatedStackInformation().error.get('confirm-password')">{{activatedStackInformation().error.get('confirm-password')}}</span>
                            </th>
                            <td>
                                <input type="password" [(ngModel)]="activatedStackInformation().confirmAdminPassword"
                                    name="password" />
                            </td>
                        </tr>
                        <tr title="'Confirm the region to deploy ' + productName + ' to"
                            [ngClass]="{'error': activatedStackInformation().error.get('region')}">
                            <th>
                                <span>Region</span>
                                <i>Region to deploy {{ productName }} to, the default is US East (North
                                    Virginia)</i>
                                <span class="error-text"
                                    *ngIf="activatedStackInformation().error.get('region')">{{activatedStackInformation().error.get('region')}}</span>
                            </th>
                            <td>
                                <zf-dropdown [elements]="regions" inputId="activate-regions-select"
                                    (selectElement)="activatedStackInformation().region = $event"
                                    [value]="activatedStackInformation().region" placeholder="Select region">
                                    <ng-template #zfDropdownElementTemplate let-region>
                                        <span>{{ region }}</span>
                                    </ng-template>
                                </zf-dropdown>
                            </td>
                        </tr>
                        <tr title="Add any IPv4 CIDR blocks to allow access"
                            [ngClass]="{'error': activatedStackInformation().error.get('ipv4')}">
                            <th>
                                <span>IPv4 list of CIDR blocks</span>
                                <i>List of IPv4 CIDR blocks from where access is allowed add each entry to a new
                                    line. Blocks must be valid IPv4 CIDR ranges</i>
                                <i>Example: 10.1.1.1/29 is incorrect, instead enter 10.1.1.0/29</i>
                                <span class="error-text"
                                    *ngIf="activatedStackInformation().error.get('ipv4')">{{activatedStackInformation().error.get('ipv4')}}</span>
                            </th>
                            <td>
                                <textarea type="text" [(ngModel)]="ipV4" name="ipv4CIDRList">
                          </textarea>
                            </td>
                        </tr>
                        <tr title="Add any IPv6 CIDR blocks to allow access"
                            [ngClass]="{'error': activatedStackInformation().error.get('ipv6')}">
                            <th>
                                <span>IPv6 list of CIDR blocks</span>
                                <i>List of IPv6 CIDR blocks from where access is allowed. Add each entry to a new line.
                                    Blocks must be valid IPv6 CIDR ranges</i>
                                <i>Example: 2001:db8:85a3::8a2e:370:7336/126 is incorrect, instead enter
                                    2001:0db8:85a3:0000:0000:8a2e:0370:7334/126</i>
                                <span class="error-text"
                                    *ngIf="activatedStackInformation().error.get('ipv6')">{{activatedStackInformation().error.get('ipv6')}}</span>
                            </th>
                            <td>
                                <textarea type="text" [(ngModel)]="ipV6" name="ipv6CIDRList">
                          </textarea>
                            </td>
                        </tr>
                    </table>
                </form>
            </ng-container>
            <ng-container *ngIf="currentState() === ProvisionState.PROVISION" modal-footer>
                <span>The selected region cannot be altered once deployed</span>
                <button class="danger" (click)="prepareProvision($event)">
                    <span>Provision</span>
                </button>
            </ng-container>
            <ng-container *ngIf="currentState() === ProvisionState.CONFIRMATION" modal-body>
                <div class="confirmation-icon">
                    <span class="expired large-icon">&#9888;</span>
                </div>
                <div class="confirmation-text">
                    <p>Are you sure you want to provision <b>{{ targetDeployment().serialNumber }}</b>?</p>
                    <p>The instance will be deployed in <b>{{ provisionRegion() }}</b>, as {{provisionDeploymentType()
                        === 'Enterprise' ? 'an' : 'a'}} <b>{{ provisionDeploymentType() }}</b> deployment.</p>
                    <p>This cannot be changed after you confirm.</p>
                </div>
            </ng-container>
            <ng-container *ngIf="currentState() === ProvisionState.PRE_REQUISITE_FAILURE" modal-body>
                <div class="confirmation-icon">
                    <span class="expired large-icon">&#9888;</span>
                </div>
                <div class="confirmation-text">
                    <p>
                        Deployment cannot proceed.
                    </p>
                    <p>
                        This could be because of the following issues:
                    </p>
                    <ul>
                        <li>No compute units associated with deployment</li>
                        <li>No online storage associated with deployment</li>
                        <li>Compute or online storage has already expired</li>
                    </ul>
                    <p>
                        Please contact your Fortinet sales representative to resolve this issue.
                    </p>
                    <p>
                        No action has been taken.
                    </p>
                </div>
            </ng-container>
            <ng-container *ngIf="currentState() === ProvisionState.CONFIRMATION" modal-footer>
                <button class="btn" (click)="editProvision($event)">
                    <span>Edit</span>
                </button>
                <button class="danger" (click)="confirmDeployment($event)">
                    <span *ngIf="!actionInProgress()">Confirm</span>
                    <img *ngIf="actionInProgress()" src="assets/icons/loader.gif" width="20" height="20"
                        srcset="assets/icons/loader.gif" src-orig="assets/icons/loader.gif">
                </button>
            </ng-container>
            <ng-container *ngIf="currentState() === ProvisionState.NOT_APPROVED" modal-body>
                <div class="confirmation-icon">
                    <span class="expired large-icon">&#9888;</span>
                </div>
                <div class="confirmation-text">
                    <p>
                        You cannot provision instance <b>{{ targetDeployment().serialNumber }}</b>
                        it requires prior approval.
                    </p>
                    <p>
                        To obtain approval please contact your Fortinet Sales Representative providing the following
                        serial number <b>{{ targetDeployment().serialNumber }}</b>
                    </p>
                    <p>
                        No action has been taken.
                    </p>
                </div>
            </ng-container>
            <ng-container *ngIf="currentState() === ProvisionState.BLOCKED_BY_REQUEST" modal-body>
                <div class="confirmation-icon">
                    <span class="expired large-icon">&#9888;</span>
                </div>
                <div class="confirmation-text">
                    <p>
                        Provisioning cannot be processed for <b>{{ targetDeployment().serialNumber }}</b> because
                    </p>
                    <ul *ngIf="apiError()" class="api-error">
                        <li>{{ apiError() }}</li>
                    </ul>
                    <p>
                        In order to proceed correct any mistakes alternatively please contact your Fortinet Sales
                        Representative, or open a support ticket via Fortinet Support.
                    </p>
                    <p>
                        No action has been taken.
                    </p>
                </div>
            </ng-container>
            <ng-container
                *ngIf="currentState() === ProvisionState.NOT_APPROVED || currentState() === ProvisionState.PRE_REQUISITE_FAILURE || currentState() === ProvisionState.BLOCKED_BY_REQUEST"
                modal-footer>
                <button *ngIf="currentState() === ProvisionState.BLOCKED_BY_REQUEST" class="btn"
                    (click)="editProvision($event)">
                    <span>Edit</span>
                </button>
                <button (click)="closeProvision($event)" class="danger">
                    <span>Close</span>
                </button>
            </ng-container>
        </zf-modal>

        <zf-modal #deleteConfirmationModal *ngIf="!!targetDeployment()" class="small-dialog">
            <ng-container modal-body>
                <div class="confirmation-icon">
                    <span class="expired large-icon">&#9888;</span>
                </div>
                <div class="confirmation-text">
                    <p>Are you sure you want to delete <b>{{ targetDeployment().serialNumber }}</b>?</p>
                    <p>This is a destructive action, and cannot be undone, all data will be removed.</p>
                </div>
            </ng-container>
            <ng-container modal-footer>
                <button class="danger" (click)="deleteDeployment()">
                    <span *ngIf="!actionInProgress()">Confirm</span>
                    <img *ngIf="actionInProgress()" src="assets/icons/loader.gif" width="20" height="20"
                        srcset="assets/icons/loader.gif" src-orig="assets/icons/loader.gif">
                </button>
            </ng-container>
        </zf-modal>

        <zf-modal #updateConfirmationModal *ngIf="!!targetDeployment()" class="small-dialog">
            <ng-container modal-body>
                <div class="confirmation-icon">
                    <span class="expired large-icon">&#9888;</span>
                </div>
                <div class="confirmation-text">
                    <p>Are you sure you want to apply new entitlements to <b>{{ targetDeployment().serialNumber }}</b>?
                    </p>
                    <p>The following changes will occur:</p>
                    <ol style="padding-left: 12px;">
                        <li *ngIf="!targetDeployment().isComputeEqual">
                            Update Compute from <b>{{ targetDeployment().information.deploymentSKU.compute.quantity * 10
                                || 0 }} FCU</b>
                            to <b>{{ targetDeployment().entitlement.compute.quantity * 10 || 0 }} FCU</b>.
                        </li>
                        <li *ngIf="targetDeployment().isComputeEqual">
                            No changes will be applied to Compute.
                        </li>
                        <li *ngIf="!targetDeployment().isOnlineEqual">
                            Update Online storage from <b>{{
                                targetDeployment().information.deploymentSKU.onlineStorage.quantity * 500 || 0 }} GB</b>
                            to <b>{{ targetDeployment().entitlement.onlineStorage.quantity * 500 || 0 }} GB</b>.
                        </li>
                        <li *ngIf="targetDeployment().isOnlineEqual">
                            No changes will be applied to Online storage.
                        </li>
                        <li *ngIf="!targetDeployment().isArchiveEqual">
                            Update Archive storage from <b>{{
                                targetDeployment().information.deploymentSKU.archiveStorage.quantity * 500 || 0 }} GB</b>
                            to <b>{{ targetDeployment().entitlement.archiveStorage.quantity * 500 || 0 }} GB</b>.
                        </li>
                        <li *ngIf="targetDeployment().isArchiveEqual">
                            No changes will be applied to Archive storage.
                        </li>
                    </ol>
                    <p>This action may result in a short period of downtime whilst the new entitlements take affect.</p>
                </div>
            </ng-container>
            <ng-container modal-footer>
                <button class="danger" (click)="updateDeployment()">
                    <span *ngIf="!actionInProgress()">Confirm</span>
                    <img *ngIf="actionInProgress()" src="assets/icons/loader.gif" width="20" height="20"
                        srcset="assets/icons/loader.gif" src-orig="assets/icons/loader.gif">
                </button>
            </ng-container>
        </zf-modal>

        <zf-modal #statusModal *ngIf="!!statusDeployment()" (onClose)="stopStatus()">
            <ng-container modal-header>Provision status for {{ statusDeployment().serialNumber}}</ng-container>
            <ng-container modal-body>
                <table class="status-table bordered stretched">
                    <thead>
                        <tr>
                            <th>
                                Stage
                            </th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <!--First status -- initializing-->
                            <td>{{Status.INITIALIZING.pascalToHumanReadable()}}</td>
                            <td>Preparing FortiSIEM environment for use</td>
                            <td *ngIf="
                        statusDeployment().information.status === Status.INITIALIZING;
                            then loading
                            else complete"></td>
                        </tr>
                        <tr>
                            <!--After Initializing status -- CreateInProgress-->
                            <td>{{Status.CREATE_IN_PROGRESS.pascalToHumanReadable()}}</td>
                            <td>Creating initial deployment resources for FortiSIEM</td>
                            <td *ngIf="
                        statusDeployment().information.status !== Status.CREATE_IN_PROGRESS
                        && statusDeployment().information.status !== Status.INITIALIZING;
                            then complete
                            else loading"></td>
                        </tr>
                        <tr>
                            <td>{{Status.LICENSE_IN_PROGRESS.pascalToHumanReadable()}}</td>
                            <td>Licensing FortiSIEM for first time use</td>
                            <td *ngIf="
                        statusDeployment().information.status !== Status.LICENSE_IN_PROGRESS
                        && statusDeployment().information.status !== Status.CREATE_IN_PROGRESS
                        && statusDeployment().information.status !== Status.INITIALIZING;
                            then complete
                            else loading"></td>
                        </tr>
                        <tr>
                            <td>{{Status.SETUP_IN_PROGRESS.pascalToHumanReadable()}}</td>
                            <td>Setting up FortiSIEM for first time use</td>
                            <td *ngIf="
                        statusDeployment().information.status !== Status.SETUP_INITIALIZING
                        && statusDeployment().information.status !== Status.SETUP_IN_PROGRESS
                        && statusDeployment().information.status !== Status.LICENSE_IN_PROGRESS
                        && statusDeployment().information.status !== Status.CREATE_IN_PROGRESS
                        && statusDeployment().information.status !== Status.INITIALIZING;
                            then complete
                            else loading"></td>
                        </tr>
                        <tr>
                            <td>{{Status.COMPLETE.pascalToHumanReadable()}}</td>
                            <td>FortiSIEM ready for use</td>
                            <td *ngIf="
                        statusDeployment().information.status === Status.COMPLETE
                        || statusDeployment().information.status === Status.UPDATE_COMPLETED;
                            then complete
                            else loading"></td>
                        </tr>
                    </tbody>
                </table>
                <ng-template #loading>
                    <td>
                        <div class="loading"></div>
                    </td>
                </ng-template>
                <ng-template #complete>
                    <td>&#9989;</td>
                </ng-template>
                <ng-template #empty>
                    <td></td>
                </ng-template>
            </ng-container>
            <ng-container modal-footer>

            </ng-container>
        </zf-modal>
    </div>
</div>
